import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TdCoreModule } from '../core/td-core.module';
import { CreateAccountStore } from '../../../account/store/create-account.store';
import { TdStartFlowStore } from './store/td-start-flow.store';

@NgModule({
  declarations: [],
  providers: [CreateAccountStore, TdStartFlowStore],
  imports: [MatDialogModule, TdCoreModule],
})
export class TdStartFlowModule {
  constructor(tdStartFlowStore: TdStartFlowStore) {
    tdStartFlowStore.initialize();
  }
}
